import $ from 'jquery';

$(function () {


  $('.btn-mobile').on('click', function() {
        $('.nav-mobile').toggleClass('active');
        $('.overlay').toggleClass('active');
  });

  $('.menu-mobile__btn').on('click', function() {
    $(this).siblings('.submenu').addClass('active');
  });

  $('.submenu__return').on('click', function() {
    $(this).parents('.submenu').removeClass('active');
  });

  $('.card-mask').each(function() {

    const $btn = $(this).find('.card-mask__content .btn');
    const $thumbnail = $(this).find('.card-mask__thumbnail');

    $btn.on('mouseenter', function() {
      $thumbnail.addClass('card-mask__thumbnail--active');
    }).on('mouseleave', function() {
      $thumbnail.removeClass('card-mask__thumbnail--active');
    });

  });



});
